import config from '@/config';
import { fetchData } from '@/model/utils/fetch';

export const fetchRecentlyPlayed = async ({
  authToken,
  locale,
  market_country,
  market_region,
  limit,
}: {
  authToken: string;
  locale?: string;
  market_country?: string;
  market_region?: string;
  limit?: number;
}) => {
  try {
    const res = await fetchData<{
      [key: string]: any;
    }>({
      url: `${config.urls.bffBaseUrl}/recently-played`,
      headers: { authorization: `Bearer ${authToken}` },
      queryParameters: {
        market_country,
        market_region,
        locale,
        base_path: config.base_path,
        ...(limit ? { limit } : null),
      },
    });

    return {
      status: 200,
      data: res.data,
    };
  } catch (err) {
    console.error(
      `There was a problem while fetching RecentlyPlayed games. ${config.urls.bffBaseUrl}/recently-played.`
    );
    console.error(err);

    return {
      // @ts-ignore
      status: err.status,
      data: [],
    };
  }
};
